import { useAuth, useMigration } from '@privemind/auth';
import { portfolioAuthIntegration, PortfolioUserData } from './auth-integration';

export function usePortfolioAuth() {
  // Configure auth with portfolio-specific settings
  const authConfig = {
    legacyDataKey: 'cryptoPortfolio',
    autoLockTimeout: 15 * 60 * 1000, // 15 minutes
    onLogin: async (user: any) => {
      console.log('Portfolio user logged in:', user.username);
      // Handle portfolio-specific login logic
    },
    onLogout: async () => {
      console.log('Portfolio user logged out');
      // Handle portfolio-specific logout logic
    }
  };

  // Use the auth hook with portfolio integration
  const auth = useAuth<PortfolioUserData>(authConfig, portfolioAuthIntegration);

  // Use migration hook for legacy localStorage data
  const migration = useMigration<PortfolioUserData>('cryptoPortfolio');

  // Enhanced migration function for portfolio data
  const migratePortfolioData = async () => {
    if (!migration.migrationData?.userData) return;

    await migration.migrateLegacyData(async (legacyData) => {
      // Convert legacy data to new format if needed
      const portfolioData: PortfolioUserData = {
        buckets: legacyData.buckets || {},
        assets: legacyData.assets || {},
        cacheData: legacyData.cacheData || {},
        lastModified: new Date().toISOString(),
        version: '1.0.0'
      };

      // Save to auth system
      if (auth.saveUserData) {
        const password = 'user-entered-password'; // Would come from UI
        await auth.saveUserData(portfolioData, password);
      }
    });
  };

  return {
    // Auth state and actions
    ...auth,
    
    // Migration state and actions
    migration: {
      ...migration,
      migratePortfolioData,
    },
    
    // Combined state
    isReady: auth.isAuthenticated && !migration.shouldPromptMigration(),
    needsMigration: migration.shouldPromptMigration(),
  };
}
